import { convertUtcToAmPm } from "../../../_scripts/utils/date";
import { isMobile } from "../../../_scripts/utils/navigator";
import { fetchAnimalDetails, fetchAnimalForAdoption, fetchShelter } from "./services";

const animalDetailPage = jQuery(".animal-detail--view-page");
const googleMapKey = `AIzaSyC0HuKQooIVPxFZPmeezGEG2aAWXmvwEw0`; // To do: add to drupal config
const mapEmbedURL = `https://www.google.com/maps/embed/v1/place`;
const fallbackImage = "/themes/custom/rspca/images/rspca_placeholder.png";

export const initAnimalDetail = async () => {
  if (animalDetailPage.length < 1) return;
  $(".breadcrumb__list > .breadcrumb__item:last-child").hide();
  try {
    const petId = getPetIdFromURL();
    // const animal = await fetchAnimalDetails(petId);
    const [animal, animalFromList] = await Promise.all([
      await fetchAnimalDetails(petId),
      await fetchAnimalForAdoption({ Limit: 1, AnimalId: petId })
    ]);

    animal.breed = animalFromList?.animals[0]?.animalos__Primary_Breed__r?.Name;
    const animalShelterId = animal?.animalos__Current_Site__c;

    animal.images = animalFromList?.animals?.[0]?.OneDrive_Files__r ?? [];



    const onedriveFiles = (
      Array.isArray(animalFromList?.animals) &&
      animalFromList.animals[0] &&
      Array.isArray(animalFromList.animals[0].OneDrive_Files__r) &&
      animalFromList.animals[0].OneDrive_Files__r[0]
    ) || null;

    animal.image = onedriveFiles?.Thumbnail_URL__c || fallbackImage;

    if (!onedriveFiles?.Thumbnail_URL__c) {
      animal.missingImage = true;
    }

    const [shelter, similarAnimals] = await Promise.all([
      animalShelterId ? fetchShelter(animalShelterId) : null,
      fetchAnimalForAdoption({ AnimalStatus: animal.animalos__Status__c, AnimalType: animal.animalos__Type__c, Limit: 5 })
    ]);

    animal.shelter = shelter;
    animal.similarAnimal = similarAnimals;

    loadAnimalContentIntoView(animal);
  } catch (error) {
    console.log(`Error is`, error);
    console.error(`Error while fetching pet details`);
    animalDetailPage.html(`
      <div class='mb-large mt-large flex flex-col items-center justify-center' style='gap:20px;'>
        <div class='text-base'>Unable to load pet details</div>
        <a href='/adopt-pet' class='button button-primary button-rounded text-center'>Back to listing</a>
      </div>
    `);
  } finally {
    animalDetailPage.removeClass("loading");
  }
}


const getPetIdFromURL = () => {
  // 1. Try query param (?petID=123)
  const params = new URLSearchParams(window.location.search);
  const petIdFromQuery = params.get('petId');

  if (petIdFromQuery) {
    return petIdFromQuery;
  }

  // 2. Fallback to old URL pattern (/pet/123)
  const url = window.location.href;
  const idRegex = /\/pet\/([^/]+)\/?$/;
  const match = url.match(idRegex);

  if (match) {
    return match[1];
  }

  throw new Error("Pet Id missing from URL");
};

const loadAnimalContentIntoView = (data) => {
  $("title").prepend(`${data?.animalos__Animal_Name__c} `);

  $(".breadcrumb__list > .breadcrumb__item:last-child").html(`${data.Name}`);
  $(".breadcrumb__list > .breadcrumb__item:last-child").show();
  
  // Banner
  let bannerBlock = animalDetailPage.find(".animal-banner");

  if (data.images.length < 1) {
    bannerBlock.find('.animal-banner-image').addClass('fallback-image');
    bannerBlock.find('.animal-banner-image').append(`<img src='${fallbackImage}' alt='data?.animalos__Animal_Name__c'/>`)
  } else {
    bannerBlock.find('.animal-banner-image').html('');
    data.images.forEach(function (image) {
      if(image?.Is_Primary__c) {
        bannerBlock.find('.animal-banner-image').prepend(`<div class='banner-image_wrapper'><img src='${image.Thumbnail_URL__c}' alt='data?.animalos__Animal_Name__c'/></div>`)
      } else {
        bannerBlock.find('.animal-banner-image').append(`<div class='banner-image_wrapper'><img src='${image.Thumbnail_URL__c}' alt='data?.animalos__Animal_Name__c'/></div>`)
      }
    });
  }
  
  let bannerHTML = bannerBlock.html();

  bannerHTML = bannerHTML
    .replaceAll('{{name}}', data?.animalos__Animal_Name__c)
    .replace('{{id}}', data?.Name)
    .replace('{{type}}', data?.animalos__Type__c)
    .replace('{{breed}}', data?.breed || "-")
    .replace('{{age}}', data?.animalos__Calculated_Age__c || "-")
    .replace('{{gender}}', data?.animalos__Gender__c)
    .replace('{{size}}', data?.animalos__Size__c || "-")
    .replace('{{color}}', data?.animalos__Primary_Colour__c)
    .replace('{{location}}', data?.shelter?.Name || "")
    .replace('{{health_checked}}', data?.Adoption_Health_Check_Completed__c || false ? "Yes" : "No")
    .replace('{{desexed}}', data?.animalos__Neutered_Spayed__c || false ? "Yes" : "No")
    .replace('{{microchipped}}', data?.animalos__Microchip_Number__c || false ? "Yes" : "No")
    .replace('{{adoption_fee}}', data?.animalos__Adoption_Fee__c ? `$${data?.animalos__Adoption_Fee__c}` : "");
  bannerBlock.html(bannerHTML);


  // Initialize slide when there is more that 1 images
  if(bannerBlock.find(".animal-banner-image > .banner-image_wrapper").length > 1) {
    setTimeout(() => {
      bannerBlock.find(".animal-banner-image").slick({
        dots: false,
        infinite: false,
        autoplay: false,
        autoplaySpeed: 3000,
        slidesToShow: 1,
        speed: 300,
        slidesToScroll: 1,
        arrows: true,
        variableWidth: false,
      });
    }, 100);
  }

  initSharer();

  if (data.animalos__Status__c != 'Available For Adoption') {
    bannerBlock.find(".adoption-fee-inclusions").remove();
    bannerBlock.find(".animal_profile-share-wrapper").addClass("mt-medium");
    animalDetailPage.find(".pet-profile_adoption-recommendations").closest('.field--name-field-blocks').remove();
    animalDetailPage.find(".animal_location").closest('.field--name-field-blocks').remove();
    animalDetailPage.find(".animal-video").closest('.field--name-field-blocks').remove();
    animalDetailPage.find(".adoption-process").closest('.field--name-field-blocks').remove();

    bannerBlock.find('li:has(span.label:contains("Adoption fee:"))').remove();
  } else {
    // Adoption Recommendation
    const adoptionRecommendations = animalDetailPage.find(".pet-profile_adoption-recommendations-list");

    adoptionRecommendations.find('.dog_friendly .value').html(`${data?.Dog_Friendly__c || "Unknown"}`);
    adoptionRecommendations.find('.cat_friendly .value').html(`${data?.Cat_Friendly__c || "Unknown"}`);
    adoptionRecommendations.find('.energy_level .value').html(`${data?.Energy_Level__c || "Unknown"}`);
    adoptionRecommendations.find('.household_activity_level .value').html(`${data?.Household_Activity_Level__c || "Unknown"}`);
    adoptionRecommendations.find('.child_friendly .value').html(`${data?.Child_Recommendation__c || "Unknown"}`);


    // Video
    const videoBlock = animalDetailPage.find(".animal-video");

    if (data?.Adoption_Video__c) {
      videoBlock.find(".field--name-field-media")
        .html(`
        <iframe src="${data?.Adoption_Video__c}" title="${data?.animalos__Animal_Name__c}" frameborder="0" allow="accelerometer; autoplay; clipboard-write; encrypted-media; gyroscope; picture-in-picture; web-share" referrerpolicy="strict-origin-when-cross-origin" allowfullscreen>
        </iframe>
      `);
    } else {
      videoBlock.remove();
    }


    // Animal Location
    const locationBlock = animalDetailPage.find(".animal_location");
    let locationBlockHTML = locationBlock.html();
    locationBlockHTML = locationBlockHTML
      .replace('{{name}}', data?.animalos__Animal_Name__c);

    if (data?.shelter) {
      locationBlockHTML = locationBlockHTML.replace('{{address}}', `${data.shelter?.Street_Address__c},${data.shelter?.Suburb__c}, ${data.shelter?.State__c} ${data.shelter?.Postcode__c}`);
      locationBlockHTML = locationBlockHTML.replace('{{adoptions}}', `
        <p class='my-none'>Animal viewing</p>
        <p class='my-none'>Monday: ${convertUtcToAmPm(data.shelter?.Monday_Open__c)} - ${convertUtcToAmPm(data.shelter?.Monday_Close__c)}</p>
        <p class='my-none'>Tuesday: ${convertUtcToAmPm(data.shelter?.Tuesday_Open__c)} - ${convertUtcToAmPm(data.shelter?.Tuesday_Close__c)}</p>
        <p class='my-none'>Wednesday: ${convertUtcToAmPm(data.shelter?.Wednesday_Open__c)} - ${convertUtcToAmPm(data.shelter?.Wednesday_Close__c)}</p>
        <p class='my-none'>Thursday: ${convertUtcToAmPm(data.shelter?.Thursday_Open__c)} - ${convertUtcToAmPm(data.shelter?.Thursday_Close__c)}</p>
        <p class='my-none'>Friday: ${convertUtcToAmPm(data.shelter?.Friday_Open__c)} - ${convertUtcToAmPm(data.shelter?.Friday_Close__c)}</p>
        <p class='my-none'>Saturday: ${convertUtcToAmPm(data.shelter?.Saturday_Open__c)} - ${convertUtcToAmPm(data.shelter?.Saturday_Close__c)}</p>
        <p class='my-none'>Sunday: ${convertUtcToAmPm(data.shelter?.Sunday_Open__c)} - ${convertUtcToAmPm(data.shelter?.Sunday_Close__c)}</p>
      `);
    } else {
      locationBlockHTML = locationBlockHTML.replace('{{adoptions}}', "Details missing. Please contact RSPCA team");
      locationBlockHTML = locationBlockHTML.replace('{{address}}', "Address missing. Please contact RSPCA team");
    }

    locationBlock.html(locationBlockHTML);

    let geoLocation = data.shelter?.Name;

    if (geoLocation == 'Weston') {
      geoLocation = "Rspca ACT";
    }

    if (geoLocation) {
      locationBlock.find(".map").html(`
      <iframe style="border-width:0;"
        src="${mapEmbedURL}?key=${googleMapKey}&amp;q=${geoLocation};zoom=14" frameborder="0" allowfullscreen="allowfullscreen">
      </iframe>`
      );
    } else {
      locationBlock.find(".map").remove();
    }
  }


  // Meet 
  const meetBlock = animalDetailPage.find(".animal-introduction")
  if (data?.animalos__Adoption_Profile__c) {
    let meetBlockHTML = meetBlock.html();
    meetBlockHTML = meetBlockHTML
      .replace('{{name}}', data?.animalos__Animal_Name__c)
      .replace('{{more_information}}', data?.animalos__Adoption_Profile__c)
    meetBlock.html(meetBlockHTML);
  } else {
    meetBlock.closest('.field--name-field-blocks').remove();
  }

  // Donation CTA
  const donationCtaBlock = animalDetailPage.find(".animal-donation_cta");
  let donationCtaBlockHTML = donationCtaBlock.html();
  donationCtaBlockHTML = donationCtaBlockHTML
    .replace('{{name}}', data?.animalos__Animal_Name__c);

  donationCtaBlock.html(donationCtaBlockHTML);





  // Similar Animals
  const similarAnimalBlock = animalDetailPage.find(".animal-similar_animals");
  let similarAnimalBlockHTML = similarAnimalBlock.html();
  similarAnimalBlockHTML = similarAnimalBlockHTML
    .replace('{{name}}', data?.animalos__Animal_Name__c);

  similarAnimalBlock.html(similarAnimalBlockHTML);
  similarAnimalBlock.append(generateSimilarAnimalHTML(data.similarAnimal, data.Id));
}


const generateSimilarAnimalHTML = (data, currentId) => {
  // Filter out the current animal by Id and ensure data.animals has exactly 4 items
  const filteredAnimals = data.animals.filter(animal => animal.Id !== currentId).slice(0, 4);

  // Create a document fragment for efficient DOM manipulation
  const fragment = document.createDocumentFragment();

  filteredAnimals.forEach(animal => {
    // Create HTML string using template literals
    const onedriveFiles = (
      Array.isArray(animal?.OneDrive_Files__r) &&
      animal.OneDrive_Files__r
    ) || null;

    let imageURL = onedriveFiles?.Thumbnail_URL__c || fallbackImage;
    
    if(Array.isArray(onedriveFiles) && onedriveFiles.length >= 1) {
			imageURL =  (onedriveFiles.find(x => x?.Is_Primary__c))?.Thumbnail_URL__c || onedriveFiles[0].Thumbnail_URL__c;
		}
		
    let missingImageClass = '';

    if (!onedriveFiles?.Thumbnail_URL__c) {
      missingImageClass = 'fallback-image';
    }

    const html = `
      <div class='grid-item'>
        <div class='grid-image'>
          <img src='${imageURL}' alt='${animal.animalos__Animal_Name__c}' class='${missingImageClass}'/>
        </div>
        <div class='grid-content'>
          <div class='my-small text-primary font-bold'><a href='/pet/${animal.Id}' class='text-2xl font-bold'>${animal.animalos__Animal_Name__c}</a></div>  
          <div>${animal.animalos__Primary_Breed__r?.Name || ''}</div>  
          <div>${animal.Age_for_Adoption_Website__c || ''}</div>  
        </div>
      </div>
    `;

    // Append HTML string to fragment
    fragment.appendChild($(html)[0]);
  });

  // Return the fragment wrapped in a jQuery object
  return $('<div/>', { class: 'grid' }).append(fragment);
};


const initSharer = () => {
  const block = $("#block-animal_profile-share");

  block.append(`
    <button class="share-button" data-sharer="facebook" data-title="Checkout Sharer.js!"  data-url="${window.location.href}">
        <svg width="32px" height="32px" viewBox="0 0 48 48" version="1.1" xmlns="http://www.w3.org/2000/svg" xmlns:xlink="http://www.w3.org/1999/xlink">
          <title>Messenger-color</title>
          <desc>Created with Sketch.</desc>
          <defs></defs>
            <g id="Icons" stroke="none" stroke-width="1" fill="none" fill-rule="evenodd">
                <g id="Color-" transform="translate(-301.000000, -860.000000)" fill="#67C15E">
                    <path d="M325,860 C311.745143,860 301,869.949185 301,882.222222 C301,889.215556 304.489988,895.453481 309.944099,899.526963 L309.944099,908 L318.115876,903.515111 C320.296745,904.118667 322.607155,904.444444 325,904.444444 C338.254857,904.444444 349,894.495259 349,882.222222 C349,869.949185 338.254857,860 325,860 L325,860 Z M327.385093,889.925926 L321.273292,883.407407 L309.347826,889.925926 L322.465839,876 L328.726708,882.518519 L340.503106,876 L327.385093,889.925926 L327.385093,889.925926 Z" id="Messenger"></path>
                </g>
            </g>
        </svg>
    </button> 
    <button class="share-button" data-sharer="email" data-title="Awesome Url" data-url="${window.location.href}" data-subject="Hey! Check out that URL">
      <svg width="32px" height="32px" viewBox="0 -2.5 20 20" version="1.1" xmlns="http://www.w3.org/2000/svg"
          xmlns:xlink="http://www.w3.org/1999/xlink">
          <g stroke="none" stroke-width="1" fill="none" fill-rule="evenodd">
              <g id="Dribbble-Light-Preview" transform="translate(-300.000000, -922.000000)" fill="#73C167">
                  <g id="icons" transform="translate(56.000000, 160.000000)">
                      <path
                          d="M262,764.291 L254,771.318 L246,764.281 L246,764 L262,764 L262,764.291 Z M246,775 L246,766.945 L254,773.98 L262,766.953 L262,775 L246,775 Z M244,777 L264,777 L264,762 L244,762 L244,777 Z">
                      </path>
                  </g>
              </g>
          </g>
      </svg>
    </button> 
    <button class="share-button" data-sharer="whatsapp" data-title="Checkout Sharer.js!" data-url="${window.location.href}">
      <svg width="32px" height="32px" viewBox="0 0 48 48" version="1.1" xmlns="http://www.w3.org/2000/svg" xmlns:xlink="http://www.w3.org/1999/xlink">
          <g id="Icons" stroke="none" stroke-width="1" fill="none" fill-rule="evenodd">
              <g id="Color-" transform="translate(-700.000000, -360.000000)" fill="#67C15E">
                <path d="M723.993033,360 C710.762252,360 700,370.765287 700,383.999801 C700,389.248451 701.692661,394.116025 704.570026,398.066947 L701.579605,406.983798 L710.804449,404.035539 C714.598605,406.546975 719.126434,408 724.006967,408 C737.237748,408 748,397.234315 748,384.000199 C748,370.765685 737.237748,360.000398 724.006967,360.000398 L723.993033,360.000398 L723.993033,360 Z M717.29285,372.190836 C716.827488,371.07628 716.474784,371.034071 715.769774,371.005401 C715.529728,370.991464 715.262214,370.977527 714.96564,370.977527 C714.04845,370.977527 713.089462,371.245514 712.511043,371.838033 C711.806033,372.557577 710.056843,374.23638 710.056843,377.679202 C710.056843,381.122023 712.567571,384.451756 712.905944,384.917648 C713.258648,385.382743 717.800808,392.55031 724.853297,395.471492 C730.368379,397.757149 732.00491,397.545307 733.260074,397.27732 C735.093658,396.882308 737.393002,395.527239 737.971421,393.891043 C738.54984,392.25405 738.54984,390.857171 738.380255,390.560912 C738.211068,390.264652 737.745308,390.095816 737.040298,389.742615 C736.335288,389.389811 732.90737,387.696673 732.25849,387.470894 C731.623543,387.231179 731.017259,387.315995 730.537963,387.99333 C729.860819,388.938653 729.198006,389.89831 728.661785,390.476494 C728.238619,390.928051 727.547144,390.984595 726.969123,390.744481 C726.193254,390.420348 724.021298,389.657798 721.340985,387.273388 C719.267356,385.42535 717.856938,383.125756 717.448104,382.434484 C717.038871,381.729275 717.405907,381.319529 717.729948,380.938852 C718.082653,380.501232 718.421026,380.191036 718.77373,379.781688 C719.126434,379.372738 719.323884,379.160897 719.549599,378.681068 C719.789645,378.215575 719.62006,377.735746 719.450874,377.382942 C719.281687,377.030139 717.871269,373.587317 717.29285,372.190836 Z" id="Whatsapp"></path>
              </g>
          </g>
      </svg>
    </button>
  `)

  const pageUrl = window.location.href;
  const pageTitle = "Test";


  $(document).on('click', '.share-button', function (e) {
    const platform = $(this).data('sharer');
    if (platform == 'facebook') {
      let messengerUrl = `https://www.facebook.com/dialog/send?link=${pageUrl}&redirect_uri=${pageUrl}`;

      if (isMobile()) {
        messengerUrl = `fb-messenger://share/?link=${pageUrl}`;
      }

      window.open(messengerUrl, '_blank');
    }

    if (platform == 'email') {
      const emailSubject = `Check out this page: ${pageTitle}`;
      const emailBody = `I found this interesting: ${pageUrl}`;
      const emailUrl = `mailto:?subject=${emailSubject}&body=${emailBody}`;
      window.location.href = emailUrl;
    }

    if (platform == 'whatsapp') {
      const whatsappMessage = `Check out this page: ${pageUrl}`;
      const whatsappUrl = `https://wa.me/?text=${whatsappMessage}`;

      window.open(whatsappUrl, '_blank');
    }
  })

  // window.Sharer.init();
}